module.exports = __webpack_public_path__ + "static/media/reedAGRIToolGAR1014.b2ed14d5.ico";